import moize from 'moize';
import {
  createSelector as defaultCreateSelector,
  createSelectorCreator,
} from 'reselect';
import { isServer } from '../utils';

export const m = isServer ? (fn: any) => fn : moize;

export default isServer
  ? createSelectorCreator(fn => fn)
  : defaultCreateSelector;
